// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2wH3W","info":"Note_info__1BqbG","note":"Note_note__Vgtbr","actions":"Note_actions__1Bapp"};